export default function autoSizeColumns(params, timeout = 5) {
  return timeout ? setTimeout(() => params.api.autoSizeColumns(params.api.getColumnDefs()
    ?.filter(col => !col.flex && !col.context?.ignoreResize).map(col => col.field) ?? []), 20) :
    params.api.autoSizeColumns(params.api.getColumnDefs().filter(col => !col.flex && !col.context?.ignoreResize).map(col => col.field));
}
